module.exports = __webpack_public_path__ + "img/gd-horizontal-pipe.411a1188.svg";